import { FilePond as FilePondPrimitive } from 'react-filepond';
import { UploadProps } from 'components/upload/types';
import styled, { css } from 'styled-components';

const FILEPOND_MAX_HEIGHT = '500px';
const LABEL_HEIGHT = '200px';
const SINGLE_MOBILE_HEIGHT = 150;
const SINGLE_INSET = 25;

const FilePond = styled(FilePondPrimitive)<UploadProps>`
    ${props => {
        const { variant } = props;

        return variant !== 'headless' && defaultStyles;
    }}
`;

const defaultStyles = css<UploadProps>`
    font-family: ${props => props.theme.typography.font};
    max-height: ${FILEPOND_MAX_HEIGHT};
    margin-bottom: 0;

    .filepond--panel::before {
        content: '';
        position: absolute;
        inset: 0;
        border: 1px lightgrey dashed;
        border-radius: ${props => props.theme.radius.large};
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .filepond--drop-label {
        min-height: ${LABEL_HEIGHT};
    }

    .filepond--panel-root {
        background-color: white;
    }

    && .filepond--list {
        left: 2rem;
        right: 2rem;
    }

    .filepond--file-wrapper,
    .filepond--panel-root,
    .filepond--item-panel {
        border-radius: ${props => props.theme.radius.large};
    }

    .filepond--item {
        width: calc(33.33% - 0.5rem);

        &[data-filepond-item-state='load-invalid'] {
            display: none;
        }

        @media (max-width: ${props => props.theme.breakpoint.tablet}) {
            & {
                width: calc(50% - 1rem);
            }
        }

        @media (max-width: ${props => props.theme.breakpoint.mobile}) {
            & {
                width: 100%;
            }
        }
    }

    ${props => {
        const { variant, imagePreviewHeight, fullWidth } = props;
        return (
            variant === 'single' &&
            imagePreviewHeight &&
            css`
                display: flex;
                align-items: center;
                justify-content: center;
                height: ${imagePreviewHeight}px !important;
                width: ${fullWidth ? '100% !important' : `${imagePreviewHeight}px !important`};

                @media (max-width: ${props => props.theme.breakpoint.mobile}) {
                    & {
                        height: ${SINGLE_MOBILE_HEIGHT}px !important;
                        width: ${SINGLE_MOBILE_HEIGHT}px !important;
                    }
                }

                .filepond--browser {
                    position: absolute;
                    top: 40px;
                    z-index: ${props => props.theme.zIndex.LayerFive} !important;
                }

                .filepond--browser,
                .filepond--image-preview-wrapper,
                .filepond--file-action-button {
                    cursor: pointer !important;
                }

                .filepond--drop-label {
                    min-height: auto !important;
                }

                .filepond--wrapper,
                .filepond--browser,
                .filepond--drop-label,
                .filepond--list-scroller {
                    height: ${imagePreviewHeight}px !important;
                    width: ${fullWidth ? '100% !important' : `${imagePreviewHeight}px !important`};

                    @media (max-width: ${props => props.theme.breakpoint.mobile}) {
                        & {
                            height: ${SINGLE_MOBILE_HEIGHT}px !important;
                            width: ${SINGLE_MOBILE_HEIGHT}px !important;
                        }
                    }
                }

                .filepond--drop-label {
                    position: absolute;
                    inset: 0;
                    font-size: ${props => props.theme.sizes.fonts.xs};
                }

                .filepond--list-scroller {
                    display: flex !important;
                    margin: 0;
                    align-items: center;
                    justify-content: center;
                }

                && .filepond--list {
                    user-select: none;
                    position: initial !important;
                    display: flex !important;
                    justify-content: center;
                    align-items: center;
                }

                .filepond--image-preview-wrapper,
                .filepond--item,
                .filepond--list {
                    height: ${imagePreviewHeight - SINGLE_INSET}px !important;
                    width: ${imagePreviewHeight - SINGLE_INSET}px !important;
                    margin: 0 !important;

                    @media (max-width: ${props => props.theme.breakpoint.mobile}) {
                        & {
                            height: ${SINGLE_MOBILE_HEIGHT - SINGLE_INSET}px !important;
                            width: ${SINGLE_MOBILE_HEIGHT - SINGLE_INSET}px !important;
                        }
                    }
                }
            `
        );
    }}
`;

export { FilePond };
